import { render, staticRenderFns } from "./PieChartSkeleton.vue?vue&type=template&id=47cf7b0e&scoped=true"
import script from "./PieChartSkeleton.vue?vue&type=script&lang=js"
export * from "./PieChartSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PieChartSkeleton.vue?vue&type=style&index=0&id=47cf7b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf7b0e",
  null
  
)

export default component.exports